var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoteSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7031 18.1817L29.1094 18.167M18.6914 26.4662L23.8945 26.4588M24.9147 40.9551L22.8334 40.9579C16.9466 40.9664 14.0033 40.9705 12.177 39.1531C10.3509 37.3359 10.355 34.4068 10.3633 28.5489L10.3751 20.2646C10.3834 14.4066 10.3875 11.4776 12.2189 9.65519C14.0502 7.83279 16.9936 7.82862 22.8802 7.82037L24.9615 7.81743C30.8483 7.8091 33.7917 7.80494 35.6178 9.6222C37.444 11.4395 37.4399 14.3684 37.4315 20.2264L37.4315 25.6495",
    stroke: "#141B34",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9215 44.0822L37.6807 39.8414L41.9215 44.0822ZM37.6807 39.8414C37.907 39.6153 38.1172 39.3731 38.3098 39.1168C39.1602 37.985 39.6641 36.578 39.6641 35.0532C39.6641 31.3131 36.6323 28.2812 32.8924 28.2812C29.1523 28.2812 26.1205 31.3131 26.1205 35.0532C26.1205 38.7931 29.1523 41.8249 32.8924 41.8249C34.7622 41.8249 36.4553 41.067 37.6807 39.8414Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9215 44.0822L37.6807 39.8414M37.6807 39.8414C37.907 39.6153 38.1172 39.3731 38.3098 39.1168C39.1602 37.985 39.6641 36.578 39.6641 35.0532C39.6641 31.3131 36.6323 28.2812 32.8924 28.2812C29.1523 28.2812 26.1205 31.3131 26.1205 35.0532C26.1205 38.7931 29.1523 41.8249 32.8924 41.8249C34.7622 41.8249 36.4553 41.067 37.6807 39.8414Z",
    stroke: "#141B34",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteSearch);
export default __webpack_public_path__ + "static/media/note-search.ec0130eded4d4850cfbe265d22d03db1.svg";
export { ForwardRef as ReactComponent };